require('./angular-locale_sk');
module.exports = 'ngLocale';



//////////////////
// WEBPACK FOOTER
// ./~/angular-i18n/sk.js
// module id = 347
// module chunks = 0